import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DynamicSizingGuide.module.scss';

interface ISizingBlockProps {
  dogList: string;
  sizeName: string;
  neckSize: string;
  bandWidth: string;
  onClick?: VoidFunction;
}

export default function SizingBlock({ dogList, sizeName, neckSize, bandWidth, onClick }: ISizingBlockProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.sizingBlock} onClick={onClick}>
      <h3>{sizeName}</h3>
      <div className={styles.sizeDescription}>
        {/* eslint-disable-next-line react/jsx-no-literals */}
        {neckSize} &bull; {t('band_width_wide_collar', { bandWidth })}
      </div>
      <div className={styles.dogList}>{dogList}</div>
    </div>
  );
}
